import { jsx as o } from "react/jsx-runtime";
import { NodeViewWrapper as i, NodeViewContent as l } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useEffect as p } from "react";
import { LIST_STYLES as s } from "../../constants/default-styles.mjs";
import { useGetParentCount as n } from "./use-get-parent-count.mjs";
import { getBulletListStyleType as f } from "./utils/list.mjs";
const c = ({ getPos: r, editor: m, updateAttributes: t }) => {
  const { realDepth: e } = n({ editor: m, getPos: r, nodeName: "bulletList" });
  return p(() => {
    setTimeout(() => {
      t({ depth: e });
    });
  }, [e, t]), /* @__PURE__ */ o(
    i,
    {
      as: "ul",
      style: {
        ...s,
        listStyleType: f(e)
      },
      children: /* @__PURE__ */ o(l, {})
    }
  );
};
export {
  c as CustomBulletList
};
